/**
 * Reaching for browser storage, twice guarded.
 *
 * Two separate failures hide behind `localStorage`, and only one of them is the obvious one. A
 * store that throws on *use* is the familiar case — a private window, or site data cleared under a
 * page that is still open. The other is a browser where merely *reaching for* `globalThis
 * .localStorage` throws, which is what hard-blocked site data does: the property access itself is
 * the error, so a `try` around `getItem` is too late.
 *
 * Extracted here when the local session became the second caller after `ProtocolChooser`. Two
 * callers is the threshold that moved `formatTimeAgo` out of `DevicesPage` and `Dialog` into
 * `design/`, and a second hand-rolled copy of a double guard is exactly the kind of thing that ends
 * up guarded once.
 */
export function safeStorage(): Storage | null {
  try {
    return globalThis.localStorage
  } catch {
    return null
  }
}
